/* eslint-disable camelcase */
/**
 *  Do not edit this file! It is autogenerated from the harmony composerasdfsad
 */
import {
  withLayout,
  withLayoutAccordion,

} from '@thd-olt-component-react/fusion-utils';

import { HomepageMetadata }
from '@thd-olt-component-react/metadata';

import { QuickLinks }
from '@thd-olt-component-react/quick-links';

import { BentoHero, HeroFlattenImage }
from '@thd-olt-component-react/hero';

import { RecentlyViewed, TopCategories, TodaysRecommendations }
from '@thd-olt-component-react/thd-recs-containers';

import { SpecialBuyBanner }
from '@thd-olt-component-react/special-buy-banner';

import { Endcap }
from '@thd-olt-component-react/endcap';

import { PromoVisualNavigation, VisualNavigation }
from '@thd-olt-component-react/visual-navigation';

import { ShopByCategory }
from '@thd-olt-component-react/shop-by-category';

import { StoreWorkshops }
from '@thd-olt-component-react/store-workshops';

import { PersonalizedHomeServices }
from '@thd-olt-component-react/personalized-home-services';

import { PLCCPod }
from '@thd-olt-component-react/consumer-card-messaging';

import { RetailMediaCarousel }
from '@thd-olt-component-react/retail-media-pla-sponsored-placements';

import { PopularCategories }
from '@thd-olt-component-react/related-search';

import { CapabilitiesTile }
from '@thd-olt-component-react/capabilities-tile';

import { SpotlightContainer }
from '@thd-olt-component-react/spotlight';

import { MedioInline, PiccolaPencil }
from '@thd-olt-component-react/internal-marketing-banner';

import { NewspaperModule }
from '@thd-olt-component-react/newspaper-module';

import { ProductShelf }
from '@thd-olt-component-react/product-shelf';

import { SponsoredUniversalBanner }
from '@thd-olt-component-react/sponsored-content';

export { HomepageMetadata };

export { QuickLinks };

export { BentoHero };

export { RecentlyViewed };

export { SpecialBuyBanner };

export { HeroFlattenImage };

export { Endcap };

export { PromoVisualNavigation };

export { ShopByCategory };

export { StoreWorkshops };

export { PersonalizedHomeServices };

export { PLCCPod };

export { TopCategories };

export { RetailMediaCarousel };

export { TodaysRecommendations };

export { PopularCategories };

export { CapabilitiesTile };

export { SpotlightContainer };

export { MedioInline };

export { PiccolaPencil };

export { VisualNavigation };

export { NewspaperModule };

export { ProductShelf };

export { SponsoredUniversalBanner };

const HPGuest001 = withLayout(
  [

    HomepageMetadata,

  ],

);

const HPGuest033 = withLayout(
  [

    QuickLinks,

  ],

);

const HPGuest002 = [

  withLayout(
    [

      BentoHero,
    ],

  ),

];

const HPGuest003 = withLayout(
  [

    RecentlyViewed,

  ],

);

const HPGuest004 = withLayout(
  [

    SpecialBuyBanner,

  ],

);

const HPGuest005 = withLayout(
  [

    HeroFlattenImage,

  ],

);

const HPGuest006 = withLayout(
  [

    Endcap,

  ],

);

const HPGuest007 = withLayout(
  [

    PromoVisualNavigation,

  ],

);

const HPGuest011 = withLayout(
  [

    ShopByCategory,

  ],

);

const HPGuest012 = withLayout(
  [

    StoreWorkshops,

  ],

);

const HPGuest013 = withLayout(
  [

    PersonalizedHomeServices,

  ],

);

const HPGuest014 = withLayout(
  [

    PLCCPod,

  ],

);

const HPGuest015 = withLayout(
  [

    TopCategories,

  ],

);

const HPGuest016 = withLayout(
  [

    RetailMediaCarousel,

  ],

);

const HPGuest017 = withLayout(
  [

    TodaysRecommendations,

  ],

);

const HPGuest018 = withLayout(
  [

    PopularCategories,

  ],

);

const HPGuest019 = withLayout(
  [

    CapabilitiesTile,

  ],

);

const HPGuest020 = withLayout(
  [

    SpotlightContainer,

  ],

);

const HPGuest021 = withLayout(
  [

    MedioInline,

  ],

);

const HPGuest022 = withLayout(
  [

    PiccolaPencil,

  ],

);

const HPGuest024 = withLayout(
  [

    VisualNavigation,

  ],

);

const HPGuest025 = withLayout(
  [

    NewspaperModule,

  ],

);

const HPGuest026 = withLayout(
  [

    ProductShelf,

  ],

);

const HPGuest027 = withLayout(
  [

    SponsoredUniversalBanner,

  ],

);

const ssr = typeof window === 'undefined';

export {

  HPGuest001,

  HPGuest033,

  HPGuest002,

  HPGuest003,

  HPGuest004,

  HPGuest005,

  HPGuest006,

  HPGuest007,

  HPGuest011,

  HPGuest012,

  HPGuest013,

  HPGuest014,

  HPGuest015,

  HPGuest016,

  HPGuest017,

  HPGuest018,

  HPGuest019,

  HPGuest020,

  HPGuest021,

  HPGuest022,

  HPGuest024,

  HPGuest025,

  HPGuest026,

  HPGuest027,

};